import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject, of, ReplaySubject } from 'rxjs';
import { Contents } from './icms-contents/icms-contents.interface';
import { AnyCnameRecord } from 'dns';
import { DataAccountsType } from 'src/app/account-list/services/account-list.service';
import { environment } from 'src/environments/environment';

interface ScopeElevationResponse { ok: boolean }

@Injectable({
  providedIn: 'root',
})
export class DashboardCallsService {
  private http = inject(HttpClient);

  responseData: object = {};
  private accountListData = new BehaviorSubject<any>(this.responseData);
  private accountListDataDashboard = new ReplaySubject<HttpResponse<string>>(1);
  private copsOverlayData = new Subject<any>();
  accountListData$ = this.accountListData.asObservable();
  accountListDashboard$ = this.accountListDataDashboard.asObservable();
  copsOverlayData$ = this.copsOverlayData.asObservable();

  private url: string | undefined;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  public getURL() {
    if (
      window &&
      window.location &&
      window.location.host &&
      window.location.protocol
    ) {
      this.url = window.location.protocol + '//' + window.location.host + '/';
      // for local testing
      // this.url = 'http://localhost:8080/';
      return this.url;
    } else {
      return 'Error in getting the host details';
    }
  }

  gerdashboardOverlay() {
    const URL =
      this.getURL() + 'MXGCB/REST/accountsPanel/getDashboardOverlayData.jws';
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return this.http.get("../../assets/getoffer.json");
  }

  getPromotions() {
    return this.http.get('assets/promotions.json');
  }

  quickLock(insId: any, flg: any) {
    if (flg === 'block') {
      var URL =
        this.getURL() +
        'MXGCB/CBOL/ain/dashboard/quickLock.action?acctInstanceID=' +
        insId;
    } else {
      var URL =
        this.getURL() +
        'MXGCB/CBOL/ain/dashboard/quickUnLock.action?acctInstanceID=' +
        insId;
    }
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return this.http.get("../../assets/quicklock.json");
  }

  getElevatedScope(): Observable<HttpResponse<ScopeElevationResponse>> {
    // R10 | MCOL-9109 | Decomiso Afore
    const URL = this.getURL() + 'MXGCB/REST/account/authRsaSession.jws';
    this.headers.set('Accept', 'application/json, */*');
    return this.http.get<ScopeElevationResponse>(URL, {
      withCredentials: true,
      observe: 'response',
      headers: this.headers,
    });
  }

  getaccountList(whosTalking?: string): Observable<HttpResponse<string>> {
    if (!environment.production) console.log("Trigger -> getaccountList by ", whosTalking || 'anybody');

    const URL =
      this.getURL() +
      'MXGCB/REST/accountsPanel/getCustomerAccounts.jws?ttc=742';
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });
    // return this.http.get('../../assets/dashboard_response_accounts.json')
  }

  getAccountUpdatedNames(): Observable<DataAccountsType> {
    return this.http.get<DataAccountsType>('./assets/updated_accounts_names.json');
  }

  getJsessionId() {
    const URL = this.getURL() + 'MXGCB/REST/accountsPanel/getJSession.jws';
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return JSessionID
  }

  getHarToken(data: any) {
    const URL =
      this.getURL() +
      '/MXGCB/apps/hardtoken/requestAngToken.action?authAppName=' +
      data.authAppName;
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return this.http.get('../../assets/hardtokenResponse.json');
  }

  authenticateHardToken(flow: any, data: any) {
    const requestData: any = {};
    if (flow === 'transmit') {
      requestData.transmitKey = data.transmitKey;
    }

    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    let URL = '';
    if (flow === 'transmit') {
      URL =
        this.getURL() +
        '/MXGCB/apps/hardtoken/authenticateAngToken.action?dynamicKeyCode=' +
        data.otp +
        '&dynamicKey=' +
        data.otp +
        '&authAppName=' +
        data.authAppName +
        '&transmitKey=' +
        data.transmitKey;
    } else {
      URL =
        this.getURL() +
        '/MXGCB/apps/hardtoken/authenticateAngToken.action?dynamicKeyCode=' +
        data.otp +
        '&dynamicKey=' +
        data.otp +
        '&authAppName=' +
        data.authAppName;
    }

    return this.http.post(
      URL,
      {
        ...requestData,
      },
      {
        responseType: 'text',
        observe: 'response',
        headers,
      },
    );

    // return this.http.get('../../assets/hardtokenAuthenticate.json');
  }

  rewSSOTANDC(data: AnyCnameRecord | any) {
    const URL =
      this.getURL() +
      'MXGCB/CBOL/rwl/rewsso/rewssotandcAng.action?acctInstanceId=' +
      data.instanceId +
      '&angTTC=' +
      data.ttc;
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return this.http.get('../../assets/rewSSOTANDC.json');
  }

  reEntrySSO() {
    const URL = this.getURL() + 'MXGCB/CBOL/rwl/rewsso/rewEntryAng.action';
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return this.http.get('../../assets/rewEntrySSO.json');
  }

  openRewardsUrl() {
    const URL = this.getURL() + 'MXGCB/CBOL/rwl/rewsso/rewSSOAng.action';
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });

    // return this.http.get('../../assets/openRewards.json');
  }

  getTransmitData() {
    const URL = this.getURL() + 'MXGCB/REST/hardtoken/getDataTransmit.jws';
    return this.http.get(URL, {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });
  }

  setData(data: any) {
    this.accountListData.next(data);
    this.accountListDataDashboard.next(data);
  }

  setCopsOverlayData(data: any) {
    this.copsOverlayData.next(data);
  }

  getCoreCampaign() {
    const URL = this.getURL() + 'apps/DashboardNewBanner/banner.json';
    return this.http.get(URL, {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });
  }

  getIcmsContents() {
    const URL = this.getURL() + 'apps/icms/contents.json';
    return this.http.get<Contents>(URL, {
      responseType: 'json',
      headers: this.headers,
    });
  }

  getCustomerCampaing(): Observable<any> {
    const URL =
      this.getURL() + 'MXGCB/REST/accountsPanel/getCustomerCampaing.jws';
    return this.http.post(URL, '', {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });
  }

  postCustomerCampaing(data: any) {
    const URL = this.getURL() + 'MXGCB/REST/accountsPanel/saveAMLCampaing.jws';
    return this.http.post(URL, data, {
      responseType: 'text',
      observe: 'response',
      headers: this.headers,
    });
  }
}
